<template>
  <div class="col-8 content-left">
    <div class="row">
      <transition name="fade">
        <div
          id="article-alert-message"
          v-if="alertMessage"
          class="bg-success text-white toast"
          :class="{ 'bg-danger': isErrorMessage }"
        >
          {{ alertMessage }}
        </div>
      </transition>
      <div
        class="col-12 text-right mb-3"
        v-if="$route.params.articleId"
      >
        <language-select
          v-model="language"
          @change="handleChangeLanguage"
        ></language-select>
      </div>
      <div class="col-9">
        <h3 class="article-detail-title">{{ $t("label.create") }}</h3>
        <span class="article-detail-subtitle" v-show="!article.requestedAt">{{
          $t("label.draft")
        }}</span>
      </div>
      <div class="col-3">
        <button
          class="btn sc-btn sc-btn-outline mb-3"
          v-if="showSaveButton"
          v-show="isEdit"
          @click="saveArticle"
        >
          {{ $t("button.save") }}
        </button>
        <button
          class="btn sc-btn sc-btn-opaque"
          :class="{ disabled: !checkPublish() }"
          v-if="$route.params.articleId"
          v-show="checkPublish()"
          @click="publishArticle"
        >
          <span v-if="!canPublish()">{{
            $t("button.request")
          }}</span>
          <span v-else>{{ $t("button.approve") }}</span>
        </button>
        <button
          class="btn sc-btn sc-btn-opaque"
          v-if="showSetAsBannerButton"
          @click="handleClickSetAsBannerButton"
        >
          <span>{{ $t("button.set_as_banner") }}</span>
        </button>
        <button
          class="btn sc-btn sc-btn-opaque mt-2"
          v-if="showSetAsRJCButton"
          @click="handleClickSetAsRJCButton"
        >
          <span>{{ $t("button.set_as_rjc") }}</span>
        </button>
      </div>
    </div>
    <content-tabs
      ref="contentTab"
      :activeTab="activeTab"
      :errorTabs="errorTabs"
    ></content-tabs>
    <div class="row" v-show="activeTab.name === 'เนื้อหาข่าว'">
      <content-body
        ref="contentBody"
        :articleId="articleId"
        :articleTitle="title"
        :articleBodyJson="contentJson"
        :canUpdateContent="canUpdateContent"
        @edited="updateCurrentArticle"
        @created="updateCurrentArticle($event, false)"
        @validate="setContentTabError"
      ></content-body>
      <content-meta
        ref="contentMeta"
        :articleApprovedAt="article.approvedAt"
        :dataSettings="settings"
        :cover="cover"
        :thumbnail="thumbnail"
        :canUpdateContent="canUpdateContent"
        :isThaiLanguage="isThaiLanguage"
        @cover="updateCurrentCover"
        @changeThumbnail="handleChangeThumbnail"
        @edited="updateCurrentSettings"
        @validate="setContentTabError"
      ></content-meta>
    </div>
    <div class="row" v-show="activeTab.name === 'รายละเอียดกิจกรรม'">
      <content-event
        ref="contentEvent"
        :canUpdateContent="canUpdateEventContent"
        :eventSettings="events"
        :isThaiLanguage="isThaiLanguage"
        @setEvents="updateCurrentEvents"
        @validate="setEventTabError"
      ></content-event>
    </div>
    <div class="row" v-show="activeTab.name === 'ส่งถึงใคร'">
      <content-receiver
        ref="contentReceiver"
        :canUpdateContent="canUpdateContent"
        :dataSettings="settings"
        :isThaiLanguage="isThaiLanguage"
        @setProjects="updateCurrentProjects"
        @setUserRoles="updateCurrentUserRoles"
        @setHomes="updateCurrentHomes"
        @validate="setReceiverTabError"
      ></content-receiver>
    </div>
    <publish-box
      v-if="showDialog === 'publish'"
      :article.sync="article"
      :close.sync="showDialog"
      :canPublish="canPublish()"
    ></publish-box>
    <confirm
      name="generalDialog"
      v-show="dialogs.generalDialog.isShow"
      @confirm="dialogs.generalDialog.isShow = false"
      :data="dialogs.generalDialog.data"
      :isHTML="dialogs.generalDialog.isHTML"
    ></confirm>
    <upload-banner-cover
      :isShow="dialogs.uploadBannerCover.isShow"
      :isLoading="dialogs.uploadBannerCover.isLoading"
      @cancel="handleCancelUploadBannerCover"
      @confirm="handleConfirmUploadBannerCover"
      :canEdit="canUpdateContent"
    ></upload-banner-cover>
  </div>
</template>

<script>
import axios from "axios";
import ContentTabs from "@/components/admin/view/article/create/ContentTabs";
import ContentDetailBody from "@/components/admin/view/article/create/ContentDetailBody";
import ContentMeta from "@/components/admin/view/article/create/ContentMeta";
import ContentReceiver from "@/components/admin/view/article/create/ContentReceiver";
import ContentEvent from "@/components/admin/view/article/create/ContentEvent";
import PublishBox from "@/components/admin/view/article/create/PublishBox";
import UploadBannerCover from "@/components/helper/dialog/UploadBannerCover";
import LanguageSelect from "@/lib/components/LanguageSelect";
import { localization } from "@/lib/mapper";
import * as god from "@/god";

export default {
  props: ["articleId"],
  components: {
    ContentTabs,
    "content-body": ContentDetailBody,
    "content-meta": ContentMeta,
    "content-receiver": ContentReceiver,
    "content-event": ContentEvent,
    PublishBox,
    LanguageSelect,
    UploadBannerCover
  },
  data() {
    return {
      showDialog: false,
      activeTab: { name: "เนื้อหาข่าว" },
      errorTabs: [false, false, false],
      title: "",
      contentJson: {},
      events: {},
      settings: {
        selectProjects: [],
        owner: ["visitor"],
        selectHomes: null,
        category: "2",
        album: [],
        map: {},
        file: {}
      },
      cover: {
        file: {},
        key: "",
        url: ""
      },
      thumbnail: {
        file: null,
        key: null,
        url: null
      },
      article: {},
      projects: [],
      album: [],
      isEdit: false,
      alertMessage: null,
      dialogs: {
        generalDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "",
            detail: "",
            buttonCancel: "",
            buttonSubmit: ""
          }
        },
        uploadBannerCover: {
          isShow: false,
          isLoading: false
        }
      },
      banner: null,
      voucher: null,
      language: localization.TH
    };
  },
  watch: {
    isEdit() {
      this.$emit("edited", this.isEdit);
    }
  },
  computed: {
    showSetAsBannerButton() {
      return (
        !this.$isCallCenter &&
        this.$route.params.articleId &&
        this.isArticlePublished &&
        !this.banner
      );
    },
    showSetAsRJCButton() {
      return (
        !this.$isCallCenter &&
        this.$route.params.articleId &&
        this.isArticlePublished &&
        this.articleType === 'privileges' &&
        !this.voucher
      );
    },
    articleType() {
      return this.$route.params.articleType;
    },
    isArticlePublished() {
      if (this.article && this.article.approvedAt && this.article.publishAt) {
        return true;
      }
      return false;
    },
    isArticleDeleted() {
      if (this.article && this.article.deletedAt) {
        return true;
      }
      return false;
    },
    canUpdateContent() {
      return (
        !this.$isCallCenter &&
        !this.isArticleDeleted
      );
    },
    canUpdateEventContent() {
      return (
        !this.$isCallCenter &&
        !this.isArticlePublished &&
        !this.isArticleDeleted
      );
    },
    showSaveButton() {
      return !this.$isCallCenter && this.checkSave() && !this.isArticleDeleted;
    },
    isThaiLanguage() {
      return this.language === localization.TH;
    }
  },
  methods: {
    async setup() {
      if (!this.isArticlePublished) {
        return;
      }
      await this.setupBannerAndVoucher();
    },
    async setupBannerAndVoucher() {
      const articleId = this.articleId;

      try {
        const banner = await god.getBanner(articleId);
        this.banner = { image_url: banner.image_url };
      } catch (err) {
        console.warn(err);
      }

      try {
        const voucher = await god.getVoucher(articleId);
        this.voucher = { article: voucher.article };
      } catch (err) {
        console.warn(err);
      }
    },
    handleCancelUploadBannerCover() {
      this.dialogs.uploadBannerCover.isShow = false;
    },
    async handleConfirmUploadBannerCover(image) {
      const articleId = this.articleId;

      this.dialogs.uploadBannerCover.isLoading = true;
      try {
        await god.setAsBanner(articleId, image);

        this.dialogs.uploadBannerCover.isShow = false;
        this.dialogs.uploadBannerCover.isLoading = false;

        this.goToBannerList();
      } catch (err) {
        console.error(err);
        this.dialogs.uploadBannerCover.isShow = false;
        this.dialogs.uploadBannerCover.isLoading = false;
      }
    },
    handleClickSetAsBannerButton() {
      this.dialogs.uploadBannerCover.isShow = true;
    },
    handleClickSetAsRJCButton() {
      const vm = this;
      axios
        .post(
          `${process.env.HOST}/api/admin/ruejai_club/packages/voucher`,
          {
            article_id: this.$route.params.articleId
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        ).then( res => {
          this.$router.push({ name: "RuejaiClubVoucherPackageListPage" });
        })
        .catch(e => {
          vm.alertMessage =
            "เกิดข้อผิดพลาดในการสร้าง Voucher";
          vm.isErrorMessage = true;
          setTimeout(() => {
            vm.alertMessage = null;
          }, 2500);
          throw e.message;
        });
    },
    resolveArticleType(type = "news") {
      const typeMap = {
        news: 1,
        activities: 2,
        privileges: 3
      };
      return typeMap[type];
    },
    saveSetting(setting) {
      this.settings = setting;
    },
    async saveArticle() {
      const validator = await this.validateArticle();

      if (validator.isValid()) {
        const vm = this;
        vm.projects = [];
        this.settings.selectProjects.forEach(element => {
          vm.projects.push(element.projectId);
        });
        vm.homes = this.settings.selectHomes
        vm.album = [];
        this.settings.album.forEach(element => {
          vm.album.push(element.key);
        });
        if (this.$route.params.articleId) {
          this.updateArticle();
        } else {
          this.insertArticle();
        }
      } else {
        this.setGeneralDialog(
          "ข้อมูลไม่ครบถ้วน",
          `กรุณากรอกข้อมูลที่จำเป็นในแท็บที่แจ้งข้อมูลไม่ครบ<br>
          หากกรอกข้อมูลครบถ้วนแล้ว กดบันทึกอีกครั้งครับ`,
          "ตกลง"
        );
        this.setContentTabError(validator.body && validator.meta);
      }
    },
    setGeneralDialog(title, desc, button) {
      this.dialogs.generalDialog.data.title = title || "Title";
      this.dialogs.generalDialog.data.detail = desc || "message";
      this.dialogs.generalDialog.data.buttonCancel = button || "OK";
      this.dialogs.generalDialog.isShow = true;
    },
    setConfirmDialog(title, desc, submit, cancel) {
      this.dialogs.generalDialog.data.title = title;
      this.dialogs.generalDialog.data.detail = desc;
      this.dialogs.generalDialog.data.buttonCancel = cancel;
      this.dialogs.generalDialog.data.buttonSubmit = submit;
      this.dialogs.generalDialog.isShow = true;
      this.dialogs.generalDialog.isHTML = true;
    },
    setContentTabError(isValid) {
      this.errorTabs[0] = !isValid;
      this.$refs.contentTab.$forceUpdate();
    },
    setEventTabError(isValid) {
      this.errorTabs[1] = !isValid;
      this.$refs.contentTab.$forceUpdate();
    },
    setReceiverTabError(isValid) {
      this.errorTabs[2] = !isValid;
      this.$refs.contentTab.$forceUpdate();
    },
    insertArticle() {
      const vm = this;

      const params = {
        type: this.resolveArticleType(this.articleType),
        category: vm.settings.category ? vm.settings.category : undefined,
        title: vm.title,
        coverImage: vm.cover.key,
        thumbnailImage: vm.thumbnail.key,
        content: JSON.stringify(vm.contentJson.ops),
        projectId: vm.projects.length ? vm.projects : undefined,
        clientRole: vm.settings.owner,
        album: vm.album,
        locationTitle: vm.settings.map.locationName,
        latitude: vm.settings.map.lat,
        longitude: vm.settings.map.lng,
        fileUrl: vm.settings.file.fileKey,
        fileName: vm.settings.file.name,
        homeId: vm.homes,
        privilege: vm.articleType === "news" ? null : vm.events
      }

      if (
        params.privilege
        && params.privilege.codes
        && params.privilege.codes.length > 0
      ) {
        params.privilege = {
          ...params.privilege,
          quota: params.privilege.codes.length
        }
      }

      axios
        .post(
          `${process.env.HOST}/api/admin/articles`,
          params,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        )
        .then(res => {
          if (res.status) {
            vm.isEdit = false;
            this.$emit("edited", this.isEdit);
            this.$router.push({
              name: "ArticleList",
              params: { articleType: this.articleType }
            });
          }
        })
        .catch(e => {
          vm.alertMessage =
            "กรุณาตรวจสอบข้อมูลให้ครบถ้วน แล้วลองบันทึกอีกครั้ง";
          vm.isErrorMessage = true;
          setTimeout(() => {
            vm.alertMessage = null;
          }, 2500);
          throw e.message;
        });
    },
    updateArticle() {
      const vm = this;
      const params = this.language !== localization.TH
        ? {
            title: vm.title,
            coverImage: vm.cover.key,
            thumbnailImage: vm.thumbnail.key,
            content: JSON.stringify(vm.contentJson.ops),
            type: this.resolveArticleType(this.articleType),
            clientRole: vm.settings.owner,
            homeId: vm.homes
          }
        : {
            type: this.resolveArticleType(this.articleType),
            category: vm.settings.category ? vm.settings.category : undefined,
            title: vm.title,
            coverImage: vm.cover.key,
            thumbnailImage: vm.thumbnail.key,
            content: JSON.stringify(vm.contentJson.ops),
            projectId: vm.projects.length ? vm.projects : undefined,
            homeId: vm.homes,
            clientRole: vm.settings.owner,
            album: vm.album,
            locationTitle: vm.settings.map.locationName,
            latitude: vm.settings.map.lat,
            longitude: vm.settings.map.lng,
            fileUrl: vm.settings.file.fileKey,
            fileName: vm.settings.file.name,
            privilege: vm.articleType === "news" ? null : vm.events
          };

          if (
            params.privilege
            && params.privilege.codes
            && params.privilege.codes.length > 0
          ) {
            params.privilege = {
              ...params.privilege,
              quota: params.privilege.codes.length
            }
          }

      let url = this.language === localization.TH
        ? `${process.env.HOST}/api/admin/articles/${this.$route.params.articleId}`
        : `${process.env.HOST}/api/admin/articles/${this.$route.params.articleId}/translation`

      // if (this.isArticlePublished && (this.language === localization.TH)) {
      //   url += "/published";
      // }

      const headers =
        this.language === localization.TH
          ? { Authorization: `Bearer ${localStorage.getItem("accessToken")}` }
          : {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "x-accept-language": this.language
            };

      axios
        .put(url, params, { headers })
        .then(res => {
          if (res.status) {
            vm.alertMessage = "บันทึกข้อมูลเรียบร้อย";
            vm.isErrorMessage = false;
            setTimeout(() => {
              vm.alertMessage = null;
            }, 2500);
            vm.isEdit = false;
          }
        })
        .catch(e => {
          vm.alertMessage =
            "กรุณาตรวจสอบข้อมูลให้ครบถ้วน แล้วลองบันทึกอีกครั้ง";
          vm.isErrorMessage = true;
          setTimeout(() => {
            vm.alertMessage = null;
          }, 2500);

          throw e.message;
        });
    },
    publishArticle() {
      if (this.checkPublish()) {
        this.showDialog = "publish";
      }
    },
    checkSave() {
      if (
        localStorage.getItem("adminRole") === "3" &&
        this.article.requestedAt
      ) {
        return false;
      }

      return true;
    },
    checkPublish() {
      let valid = true;

      if (["1", "2"].indexOf(localStorage.getItem("adminRole")) < 0) {
        if (this.article.requestedAt) {
          valid = false;
        }
      }
      if (this.isEdit) {
        valid = false;
      }
      if (this.article.approvedAt) {
        valid = false;
      }
      if (this.article.content === null) {
        valid = false;
      }

      return valid;
    },
    getArticle(articleId) {
      const vm = this;
      const headers =
        this.language === localization.TH
          ? { Authorization: `Bearer ${localStorage.getItem("accessToken")}` }
          : {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "x-accept-language": this.language
            };

      return axios
        .get(`${process.env.HOST}/api/admin/articles/${articleId}`, { headers })
        .then(res => {
          if (res.data) {
            vm.title = res.data.title;
            vm.contentJson = JSON.parse(res.data.content);
            vm.downloadImage(res.data.cover);
            vm.downloadThumbnail(res.data.thumbnail);

            vm.events = res.data.privilege;

            vm.settings.selectProjects = res.data.articlesProjects;
            vm.settings.selectHomes = res.data.articlesHomes;
            vm.settings.owner = [];
            if (res.data.ownerStatus) {
              vm.settings.owner.push("owner");
            }
            if (res.data.renterStatus) {
              vm.settings.owner.push("renter");
            }
            if (res.data.contractStatus) {
              vm.settings.owner.push("contract");
            }
            if (res.data.bookingStatus) {
              vm.settings.owner.push("booking");
            }
            if (res.data.residentStatus) {
              vm.settings.owner.push("resident");
            }
            if (res.data.visitorStatus) {
              vm.settings.owner.push("visitor");
            }
            vm.downloadAlbum(res.data.articlesAlbums);
            vm.settings.map = {
              lat: res.data.latitude,
              lng: res.data.longitude,
              locationName: res.data.locationTitle
            };
            vm.settings.file = {
              fileKey: res.data.fileUrl,
              name: res.data.fileName
            };
            vm.article = res.data;
          }
        })
        .catch(e => {
          throw e;
        });
    },
    goToBannerList() {
      this.$router.push({ name: "BannerList" });
    },
    downloadImage(imageKey) {
      const vm = this;
      if (imageKey) {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey
            }
          })
          .then(res => {
            vm.cover.key = imageKey;
            vm.cover.url = res.data.url;
            vm.$emit("cover", vm.cover);
          })
          .catch(e => {
            throw e.message;
          });
      }
    },
    downloadThumbnail(imageKey) {
      const vm = this;
      if (imageKey) {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey
            }
          })
          .then(res => {
            vm.thumbnail.key = imageKey;
            vm.thumbnail.url = res.data.url;
          })
          .catch(e => {
            throw e.message;
          });
      }
    },
    downloadAlbum(album) {
      const vm = this;
      if (album) {
        album.forEach((val, index) => {
          axios
            .get(`${process.env.HOST}/api/downloads/image`, {
              params: {
                imageKey: val.image
              }
            })
            .then(res => {
              vm.$set(vm.settings.album, index, {
                key: val.image,
                url: res.data.url,
                name: `image${index + 1}`
              });
            })
            .catch(e => {
              throw e.message;
            });
        });
      }
    },
    updateCurrentArticle(editedContent, edited = true) {
      this.title = editedContent.title;
      this.contentJson = editedContent.contentJson;
      this.isEdit = edited;
      this.$emit("updated", editedContent);
    },
    updateCurrentSettings(editedSettings) {
      this.settings = editedSettings;
      this.isEdit = true;
    },
    updateCurrentCover(editedCover) {
      this.cover = editedCover;
      this.isEdit = true;
      this.$emit("cover", editedCover);
    },
    updateCurrentProjects(editedProjects) {
      this.settings.selectProjects = editedProjects;
      this.isEdit = true;
    },
    updateCurrentUserRoles(editedUserRoles) {
      this.settings.owner = editedUserRoles;
      this.isEdit = true;
    },
    updateCurrentHomes(editedHomes) {
      this.settings.selectHomes = editedHomes;
      this.isEdit = true;
    },
    updateCurrentEvents(editedEvents) {
      this.events = editedEvents;
      this.isEdit = true;
    },
    async validateArticle() {
      const vm = this;
      const result = {
        body: false,
        meta: false,
        receiver: false,
        event: false,
        isValid() {
          if (vm.articleType === "news") {
            return this.body && this.meta && this.receiver;
          }

          return this.body && this.meta && this.receiver && this.event;
        }
      };

      result.body = await this.$refs.contentBody.validate();
      result.meta = await this.$refs.contentMeta.validate();
      result.receiver = await this.$refs.contentReceiver.validate();
      result.event = await this.$refs.contentEvent.validate();

      return result;
    },
    async handleChangeThumbnail(file) {
      this.isEdit = true;
      const { imageKey } = await this.uploadImage(file);

      const url = URL.createObjectURL(file);
      this.thumbnail.file = file;
      this.thumbnail.key = imageKey;
      this.thumbnail.url = url;
    },
    async uploadImage(img) {
      const headers = { "content-type": img.type };
      const { data } = await this.getUploadMeta(img);
      const response = await axios.put(data.url, img, { headers });

      return data;
    },
    getUploadMeta(img) {
      const params = {
        imageType: img.type,
        imageName: `articlecover${Date.now()}`,
        featureName: "article"
      };

      return axios.get(`${process.env.HOST}/api/uploads/image`, { params });
    },
    handleChangeLanguage() {
      this.$on("change:article-tab", tab => {
        this.activeTab = tab;
      });

      this.getArticle(this.articleId).then(() => {
        this.setup();
      });
    },
    canPublish() {
      const adminProjects = localStorage.getItem("adminProjects").split(",");
      const articlesProjects = this.article.articlesProjects
        ? this.article.articlesProjects
        : [];
      const canAccessArticle = adminProjects.some(projectId =>
        articlesProjects
          .map(articleProject => articleProject.projectId)
          .includes(projectId)
      );

      const canPublish =
        localStorage.getItem("adminRole") === "1" ||
        (localStorage.getItem("adminRole") === "2" && canAccessArticle);

      return canPublish;
    }
  },
  created() {
    this.$on("change:article-tab", tab => {
      this.activeTab = tab;
    });

    if (this.articleId) {
      this.getArticle(this.articleId).then(() => {
        this.setup();
      });
    }
  }
};
</script>

<style scoped>
.toast {
  font-size: 14px;
  position: absolute;
  border-radius: 10em;
  padding: 5px 40px;
  box-shadow: 1px 1px 15px -5px black;
  left: calc(50% - 111px);
}
.bg-danger {
  left: calc(50% - 222px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content-left {
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentDetail.vue